function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Children, createRef } from 'react';
import { safeSelect } from '@sie/web-common-utils';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import Button from '../Button';
import Icon from '../Icon';
import MediaFrame from '../MediaFrame';
import Strand from '../Strand';
import StrandStates from '../Strand/StrandStates';
/**
 * The OverlayStrand component displays a collection of UI items horizontally allowing the
 * content to scroll and keeping the height consistent
 *
 * ** Browser Support**
 *
 * This component depends on scroll-behavior and will require a polyfill for Safari
 * [Recommended PolyFill (smoothscroll-polyfill)](https://github.com/iamdustan/smoothscroll)
 * This polyfill can be loaded from  web-common browser polyfills
 *
 * **Designs**
 *
 * - [Product Strand IXD](https://atlas.np.tools.playstation.net/design/b46dafea-6646-49a9-bfb6-a9ec467c6929/1?bounds=-0.120,0.007,1.241,0.843)
 * - [Product Strand Red Lines](https://atlas.np.tools.playstation.net/design/864ab9c0-7f8e-45d4-a4b7-1dfab063ec96/1?bounds=0.379,0.673,0.385,0.262&rev=1,1,1&x=549.46,653.72,4455.94&y=809.14,3598.32,6174.10)
 * - [Editions Strand IXD](https://atlas.np.tools.playstation.net/design/f13ae03c-ae4a-433c-86db-339c1d26f71e/2?bounds=-0.206,-0.022,1.067,0.725)
 * - [Editions Strand Red Lines](https://atlas.np.tools.playstation.net/design/defebb5a-0142-4812-a676-b2fb0198f30d/5?bounds=0.344,0.412,0.515,0.368)
 * - [Overlay With Strand - MediaCarousel IXD](https://atlas.np.tools.playstation.net/design/4cf0072e-d557-4678-a0ba-8315458f5f60/23?bounds=-0.005,2.817,0.379,0.264&rev=17,23&x=519.09,1655.26&y=28535.22,86131.17)
 * - [Overlay With Strand - MediaCarousel Red Lines](https://atlas.np.tools.playstation.net/design/a8c8cdcf-4927-439b-b7b7-e631c7c3448d/8?bounds=0.130,0.535,0.214,0.149)
 *
 * **Usage**
 * Loading state
 *
 * ```jsx
 * <OverlayStrand loading loadingItem=(<div>loading...</div>)>
 * </OverlayStrand>
 * ```
 *
 * With inline error
 *
 * ```jsx
 * <OverlayStrand errorMessage="Foobar">
 * </OverlayStrand>
 * ```
 *
 * ```jsx
 * <OverlayStrand>
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 *   <div>Item 3</div>
 *   <div>Item 4</div>
 *   <div>Item 5</div>
 *   <div>Item 6</div>
 *   <div>Item 7</div>
 * </OverlayStrand>
 * ```
 */

var OverlayStrand = /*#__PURE__*/function (_Strand) {
  _inherits(OverlayStrand, _Strand);

  var _super = _createSuper(OverlayStrand);

  function OverlayStrand(props) {
    var _this;

    _classCallCheck(this, OverlayStrand);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeFrame: 0,
      focusedItem: undefined,
      gap: 0,
      itemWidth: 0,
      pageWidth: 0,
      showPreviousControl: false,
      showNextControl: false,
      totalFrames: 0
    });

    _defineProperty(_assertThisInitialized(_this), "_scrollToFrame", function (frame, behaviorType) {
      var current = _this._node.current;
      if (!current) return;
      var elementInViewPort = current.children[frame];
      elementInViewPort.scrollIntoView({
        behavior: behaviorType
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTouchStart", function (event) {
      event.preventDefault();
      _this.touchstartX = event.touches[0].clientX;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleTouchMove", function (event) {
      event.preventDefault();

      if (!_this.touchstartX) {
        return;
      }

      var xMove = event.touches[0].clientX;
      var xDiff = _this.touchstartX - xMove;
      if (xDiff > 0) _this._nextMediaFrame();
      if (xDiff < 0) _this._previousMediaFrame();
      _this.touchstartX = null;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function (event) {
      event.preventDefault();
      var key = event.key;

      if (key === 'ArrowLeft') {
        _this._previousMediaFrame();
      } else if (key === 'ArrowRight') {
        _this._nextMediaFrame();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_nextMediaFrame", function () {
      var _this$state = _this.state,
          activeFrame = _this$state.activeFrame,
          totalFrames = _this$state.totalFrames;
      var nextActiveFrame = activeFrame + 1;

      if (nextActiveFrame < totalFrames) {
        _this.setState({
          activeFrame: nextActiveFrame
        });

        _this._scrollToFrame(nextActiveFrame, 'smooth');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_previousMediaFrame", function () {
      var activeFrame = _this.state.activeFrame;
      var nextActiveFrame = activeFrame - 1;

      if (nextActiveFrame >= 0) {
        _this.setState({
          activeFrame: nextActiveFrame
        });

        _this._scrollToFrame(nextActiveFrame, 'smooth');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_computeScrollProgress", function () {
      var current = _this._node.current;
      if (!current) return;

      var scrollLeft = _this._getScrollLeft();

      var singlePageWidth = _this._getSinglePageWidth();

      var scrollWidth = _this._getScrollWidth();

      var pageCount = Math.ceil(scrollWidth / singlePageWidth);

      var isOnLastPage = _this._isOnLastPage();

      _this._onSeeked({
        progress: (scrollLeft + singlePageWidth) / scrollWidth,
        isLast: isOnLastPage,
        pageCount: pageCount
      });

      _this.setState({
        showPreviousControl: !_this._isOnFirstPage(),
        showNextControl: !isOnLastPage
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSwipeAndKeyEvents", function () {
      var current = _this._node.current;
      if (!current) return;
      current.addEventListener('touchstart', _this._handleTouchStart, false);
      current.addEventListener('touchmove', _this._handleTouchMove, false);
      current.addEventListener('keydown', _this._handleKeyDown);
    });

    _defineProperty(_assertThisInitialized(_this), "_isOnLastPage", function () {
      var _this$state2 = _this.state,
          activeFrame = _this$state2.activeFrame,
          totalFrames = _this$state2.totalFrames;
      return activeFrame === totalFrames - 1;
    });

    _defineProperty(_assertThisInitialized(_this), "_isOnFirstPage", function () {
      var activeFrame = _this.state.activeFrame;
      return activeFrame === 0;
    });

    _this._node = /*#__PURE__*/createRef();
    _this._computeScrollProgress = _this._computeScrollProgress.bind(_assertThisInitialized(_this));
    _this.touchstartX = 0;
    return _this;
  }

  _createClass(OverlayStrand, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var gap = this._getGutter();

      var itemWidth = this._getItemWidth();

      var pageWidth = this._getSinglePageWidth();

      var _this$props = this.props,
          openAtFrame = _this$props.openAtFrame,
          openScroll = _this$props.openScroll;

      this._computeScrollProgress();

      this._handleSwipeAndKeyEvents();

      this.setState({
        gap: gap,
        itemWidth: itemWidth,
        pageWidth: pageWidth
      });
      window.addEventListener('resize', this._computeScrollProgress);

      if (openScroll && openAtFrame >= 0) {
        var current = this._node.current;
        this.setState({
          activeFrame: openAtFrame,
          totalFrames: current.children.length
        });

        this._scrollToFrame(openAtFrame, 'instant');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var wasLoading = _ref.loading;
      var isLoadingNow = this.props.loading;

      if (wasLoading !== isLoadingNow) {
        this._computeScrollProgress();

        this._handleSwipeAndKeyEvents();
      }
    }
  }, {
    key: "_setFocusedItem",

    /**
     * Set state attribute `focusedItem` when tabbing through and out of elements
     * @param {(number | undefined)} idx - the value of the element on focus and on blur
     */
    value: function _setFocusedItem() {
      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.setState({
        focusedItem: idx
      });
    }
  }, {
    key: "_setTabIndex",
    value: function _setTabIndex() {
      var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var tabIndex = -1;
      var _this$state3 = this.state,
          activeFrame = _this$state3.activeFrame,
          focusedItem = _this$state3.focusedItem;
      tabIndex = idx === activeFrame || idx === activeFrame + 1 || focusedItem && idx === activeFrame - 1 ? 0 : -1;
      return tabIndex;
    }
  }, {
    key: "_setOnFocus",
    value: function _setOnFocus(event, i) {
      var current = this._node.current;
      var openAtFrame = this.props.openAtFrame;
      var _this$state4 = this.state,
          activeFrame = _this$state4.activeFrame,
          focusedItem = _this$state4.focusedItem,
          totalFrames = _this$state4.totalFrames;

      if (event.target === current.children[openAtFrame] && !focusedItem) {
        this._setFocusedItem(i);

        if (totalFrames === 2 && openAtFrame === 0) this._previousMediaFrame();
      } else if (activeFrame > i) {
        this._previousMediaFrame();

        this._setFocusedItem(i);
      } else if (i > 0) {
        this._nextMediaFrame();

        this._setFocusedItem(i);
      }
    }
    /**
     * Determine if the total scroll width is larger than page width
     * @returns boolean
     */

  }, {
    key: "_shouldStrandScroll",
    value: function _shouldStrandScroll() {
      var current = this._node.current;
      if (!current) return true;
      var _this$state5 = this.state,
          gap = _this$state5.gap,
          itemWidth = _this$state5.itemWidth,
          pageWidth = _this$state5.pageWidth;
      var useGap = gap;
      var useItemWidth = itemWidth;
      var usePageWidth = pageWidth;

      var singlePageWidth = this._getSinglePageWidth();

      if (pageWidth !== singlePageWidth) {
        useGap = this._getGutter();
        useItemWidth = this._getItemWidth();
        usePageWidth = singlePageWidth;
      } // Item width is multiplied by 1.2 as active item is slightly enlarged compared to other items


      var activeItemWidth = useItemWidth * 1.2;
      var itemWithGap = useItemWidth + useGap;
      var numChildren = current.children.length;
      var wholeScrollWidth = (numChildren - 1) * itemWithGap + activeItemWidth;
      var shouldStrandScroll = wholeScrollWidth > usePageWidth + activeItemWidth;
      return shouldStrandScroll;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var current = this._node.current;
      window.removeEventListener('resize', this._computeScrollProgress);
      current.removeEventListener('touchstart', this._handleTouchStart);
      current.removeEventListener('touchmove', this._handleTouchMove);
      current.removeEventListener('keydown', this._handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state6 = this.state,
          activeFrame = _this$state6.activeFrame,
          showPreviousControl = _this$state6.showPreviousControl,
          showNextControl = _this$state6.showNextControl;
      var _this$props2 = this.props,
          qa = _this$props2.qa,
          children = _this$props2.children,
          full = _this$props2.full,
          alignControls = _this$props2.alignControls,
          previousControlLabel = _this$props2.previousControlLabel,
          nextControlLabel = _this$props2.nextControlLabel,
          loading = _this$props2.loading,
          errorMessage = _this$props2.errorMessage,
          loadingItem = _this$props2.loadingItem;
      var childrenArray = Children.toArray(children);
      var isLoading = loading || errorMessage;

      var shouldStrandScroll = this._shouldStrandScroll();

      if (isLoading) {
        return /*#__PURE__*/React.createElement(StrandStates, {
          qa: qa,
          full: full,
          itemWidth: classNames('psw-l-w-1/1', 'psw-l-w-1/1@tablet-s', 'psw-l-w-1/1@tablet-l', 'psw-l-w-1/1@laptop', 'psw-l-w-1/1@desktop', 'psw-l-w-1/1@max'),
          loading: loading,
          errorMessage: errorMessage,
          loadingItem: loadingItem
        });
      }

      if (childrenArray.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: classNames('psw-strand', 'psw-l-anchor-center', 'psq-l-line-top', 'psw-l-align-center', full && 'psw-full')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor', 'psw-l-z-0', 'psw-l-section')
      }, /*#__PURE__*/React.createElement("ul", {
        ref: this._node,
        onScroll: this._handleScroll,
        className: classNames('psw-strand-scroller', 'psw-l-line-left-top', 'psw-list-style-none', 'psw-l-space-x-5', 'psw-p-y-4', full ? 'psw-p-x-gm' : 'psw-p-x-4', full ? 'psw-m-sub-x-gm' : 'psw-m-sub-x-4', 'psw-hide-scrollbar')
      }, childrenArray.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          "data-qa": "".concat(qa, "#item").concat(i),
          key: safeSelect(x, 'props.id') || i,
          className: classNames('psw-l-w-1/1', 'psw-l-w-1/1@tablet-s', 'psw-l-w-1/1@tablet-l', 'psw-l-w-1/1@laptop', 'psw-l-w-1/1@desktop', 'psw-l-w-1/1@max'),
          onBlur: function onBlur() {
            if (activeFrame === childrenArray.length - 1) {
              _this2._setFocusedItem();
            }
          },
          onFocus: function onFocus(event) {
            return _this2._setOnFocus(event, i);
          },
          tabIndex: _this2._setTabIndex(i)
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor-top-center', 'psw-l-top-center', 'psw-pointer-events-off', 'psw-l-w-1/1', 'psw-l-line-center', 'psw-m-t-4', alignControls === 'center' && 'psw-fill-y')
      }, alignControls === '1:1-center' && /*#__PURE__*/React.createElement(MediaFrame, {
        className: classNames('psw-l-w-1/1', 'psw-l-w-1/1@tablet-s', 'psw-l-w-1/1@tablet-l', 'psw-l-w-1/1@laptop', 'psw-l-w-1/1@desktop', 'psw-l-w-1/1@max'),
        aspectRatio: "20:9"
      }), showPreviousControl && shouldStrandScroll && /*#__PURE__*/React.createElement("div", {
        className: "psw-l-anchor-center-left psw-pointer-events-on psw-l-inline psw-l-z-1"
      }, /*#__PURE__*/React.createElement(Button, {
        qa: "".concat(qa, "#previous"),
        ctaType: "primary",
        iconOnly: true,
        onClick: this._previousMediaFrame,
        ariaLabel: previousControlLabel
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "chevron-left"
      }))), showNextControl && shouldStrandScroll && /*#__PURE__*/React.createElement("div", {
        className: "psw-l-anchor-center-right psw-pointer-events-on psw-l-inline psw-l-z-1"
      }, /*#__PURE__*/React.createElement(Button, {
        qa: "".concat(qa, "#next"),
        ctaType: "primary",
        iconOnly: true,
        onClick: this._nextMediaFrame,
        ariaLabel: nextControlLabel
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "chevron-right"
      })))));
    }
  }]);

  return OverlayStrand;
}(Strand);

OverlayStrand.defaultProps = {
  alignControls: '1:1-center',
  children: null,
  errorMessage: '',
  full: false,
  loading: false,
  loadingItem: null,
  nextControlLabel: '',
  onSeeked: function onSeeked() {},
  onNext: function onNext() {},
  onPrevious: function onPrevious() {},
  openAtFrame: null,
  openScroll: false,
  previousControlLabel: '',
  qa: 'overlayStrand'
};
OverlayStrand.propTypes = {
  /**
   * How to align the controls (vertically)
   */
  alignControls: PropTypes.oneOf(['center', '1:1-center']),

  /**
   * The collection of items to render into the strand
   */
  children: PropTypes.arrayOf(PropTypes.node),

  /**
   * The inline error message to display of the space maintained for the strand
   */
  errorMessage: PropTypes.node,

  /**
   * Whether or not the strand should be full bleed (span the entire screen width)
   */
  full: PropTypes.bool,

  /**
   * Whether the strand should be shown in a loading state
   */
  loading: PropTypes.bool,

  /**
   * The loading UI to show per placeholder item in the strand
   */
  loadingItem: PropTypes.node,

  /**
   * Screen reader label for the next control button
   */
  nextControlLabel: PropTypes.string,

  /**
   * Event callback called when the next control is interacted with (will not be called
   * for pure scrolling / swiping)
   */
  onNext: PropTypes.func,

  /**
   * Event callback, called when the content has been scrolled (roughly once per page
   * but not guarenteed)
   */
  onSeeked: PropTypes.func,

  /**
   * Event callback called when the previous control is interacted with (will  not be called
   * for pure scrolling / swiping)
   */
  onPrevious: PropTypes.func,

  /**
   * The at which the strand should scroll on instantiation
   */
  openAtFrame: PropTypes.number,

  /**
   * Determines whether or not to scroll to a frame when instantiated
   */
  openScroll: PropTypes.oneOfType([PropTypes.instanceOf(null), PropTypes.number]),

  /**
   * Screen reader label for the previous control button
   */
  previousControlLabel: PropTypes.string,

  /**
   * Unique id used for qa automation. This should be unique to the page
   */
  qa: PropTypes.string
};
export default OverlayStrand;